import { Linking } from 'react-native';

export const CVS_URL = 'https://cvs.com';

export const openCVSLink = async () => {
  try {
    await Linking.openURL(CVS_URL);
  } catch {
    // Non-blocking: no error tracking for external link failures
  }
};
